export { default } from './CommentUGCEditor';



// WEBPACK FOOTER //
// ./app/components/shared/UGC/UGCEditors/CommentUGCEditor/index.js